import { useState, useEffect } from 'react'
import RoundedButton from '../../components/buttons/RoundedButton'
import RoundedBorderButton from '../../components/buttons/RoundedBorderButton'
import * as Constants from '../../utils/constants'
import Modal from '@mui/material/Modal'
import close from '../../assets/close.png'
import strings from '../../res/strings'

const ScheduleInfoModal = (props) => {
    const interventionTypesList = props.services
    const docapescaId = props.docapescaId

    const [isPastSchedule, setIsPastSchedule] = useState(false)

    useEffect(() => {
        if(props.item) {
            const today = new Date()

            let currentDate

            if(props.item.endDate) {
                currentDate = new Date(props.item.endDate)
            } else if(props.item.startDate) {
                currentDate = new Date(props.item.startDate)
            } else {
                currentDate = new Date(props.item.accessFacilitiesStartDate)
            }

            if(currentDate >= today) {
                setIsPastSchedule(false)
            } else {
                setIsPastSchedule(true)
            }
        }
    }, [props.item])

    // Check all the dates and return first date time
    const getStartTime = () => {
        if(props.item) {
            let datesArray = []

            if(props.item.dryStartDate) {
                datesArray.push(new Date(props.item.dryStartDate))
            }

            if(props.item.swimStartDate) {
                datesArray.push(new Date(props.item.swimStartDate))
            }

            if(props.item.lineChangeStartDate) {
                datesArray.push(new Date(props.item.lineChangeStartDate))
            }

            if(props.item.supplyPersonnelStartDate) {
                datesArray.push(new Date(props.item.supplyPersonnelStartDate))
            }

            if(props.item.rippingStartDate) {
                datesArray.push(new Date(props.item.rippingStartDate))
            }

            const dates = datesArray.map(date => date.getTime())

            const minTimestamp = Math.min(...dates)
            const firstDate = new Date(minTimestamp)
            
            if(minTimestamp === Infinity) {
                return '-'
            } else {
                return formatTime(firstDate)
            } 
        }
    }

    // Handles date formatting
    const formatDate = (timeStamp) => {
        const date = new Date(timeStamp)
        const day = date.getDate()
        const month = Constants.MONTHS[date.getUTCMonth()]
        const year = date.getUTCFullYear()
        return `${day} de ${month} de ${year}`
    }

    // Handles time formatting
    const formatTime = (timeStamp) => {
        const date = new Date(timeStamp)
        const hours = date.getHours()
        const minutes = date.getMinutes()
        return `${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes} h`
    }

    // Check the service type and show matching text
    const showServiceTypeText = () => {
        if(interventionTypesList) {
            const serviceType = interventionTypesList.find((service) => service.id === props.item.scheduleTypeId)
            return serviceType && serviceType.name
        } else {
            return ''
        }
    }

    return (
        <Modal
            className='flex items-center justify-center'
            disableAutoFocus={true}
            open={props.open}
            onClose={props.onClose}
        >
            <div className='bg-white justify-center item-center mx-4 py-4 rounded-[0.625rem] w-[57.5rem]'>

                <div className='flex flex-row justify-between items-center px-6'>
                    <p className='font-montserrat font-semibold text-accent'>{strings.scheduleInfo}</p>
                    <button onClick={props.onClose}>
                        <img className='h-3 w-3 ' src={close} alt='Fechar'/>
                    </button>
                </div>

                <div className='h-px bg-neutral3 my-4'/>

                <div className='px-6'>

                    <div className='flex flex-row'>
                        <div className='flex flex-col w-1/2'>
                            <p className='font-montserrat text-sm'>{strings.clientIdentification}</p>
                            <p className='font-montserrat text-xl font-semibold'>{props.item && props.item.user.name}</p>
                        </div>

                        <div className='flex flex-col w-1/2'>
                            <p className='font-montserrat text-sm'>{strings.boatIdentification}</p>
                            <p className='font-montserrat text-xl font-semibold'>{props.item && props.item.boat.name}</p>
                        </div>
                    </div>

                    <div className='flex flex-row mt-6'>
                        <div className='flex flex-col w-1/2'>
                            <p className='font-montserrat text-sm'>{strings.registration}</p>
                            <p className='font-montserrat text-xl font-semibold'>{props.item && props.item.boat.registration}</p>
                        </div>

                        <div className='flex flex-col w-1/2'>
                            <p className='font-montserrat text-sm'>{strings.outOutLength}</p>
                            <p className='font-montserrat text-xl font-semibold'>{props.item && props.item.boat.length + strings.m}</p>
                        </div>
                    </div>

                    <div className='flex flex-row mt-6'>
                        <div className='flex flex-col w-1/2'>
                            <p className='font-montserrat text-sm'>{strings.grossTonnage}</p>
                            <p className='font-montserrat text-xl font-semibold'>{props.item && props.item.boat.grossTonnage + strings.grt}</p>
                        </div>

                        <div className='flex flex-col w-1/2'>
                            <p className='font-montserrat text-sm'>{strings.service}</p>
                            <p className='font-montserrat text-xl font-semibold'>{props.item && showServiceTypeText()}</p>
                        </div>
                    </div>

                    <div className='flex flex-row mt-6'>
                        <div className='flex flex-col w-1/2'>
                            <p className='font-montserrat text-sm'>{strings.startDate}</p>
                            <p className='font-montserrat text-xl font-semibold'>{formatDate(props.item && props.item.startDate)}</p>
                        </div>

                        <div className='flex flex-col w-1/2'>
                            <p className='font-montserrat text-sm'>{strings.endDate}</p>
                            <p className='font-montserrat text-xl font-semibold'>{props.item && props.item.scheduleTypeId === Constants.ScheduleTypes.ENERGY ? '-' : formatDate(props.item && props.item.endDate)}</p>
                        </div>
                    </div>

                    <p className='font-montserrat text-sm mt-6'>{strings.startTime}</p>
                    <p className='font-montserrat text-xl font-semibold'>{props.item && (props.item.scheduleTypeId === Constants.ScheduleTypes.FAIRING || props.item.scheduleTypeId === Constants.ScheduleTypes.FAIRINGENERGY) ? getStartTime() : '-'}</p>

                    { props.loggedUser.role === Constants.Roles.ADMINIT && isPastSchedule ?
                        <div className='flex flex-row justify-between mt-8'>
                            <div className='flex w-40 me-[11.5rem]'>
                                <RoundedButton 
                                    onClick={props.onClickCancel}
                                    text={strings.delete}
                                    height={48}
                                    bgColor='#E85F5C'
                                />
                            </div>

                            <div className='flex w-40'>
                                <RoundedBorderButton
                                    text={strings.details}
                                    onClick={props.onClickDetails}
                                    height={48}
                                    fontWeight='700'
                                />
                            </div>
                    
                        </div>

                    :   (props.item && (props.item.scheduleStatusId === Constants.ScheduleStatus.CONFIRMED || props.item.scheduleStatusId === Constants.ScheduleStatus.REJECTED)) || isPastSchedule ?
                            props.item && props.item.entityId === docapescaId ?
                                <div className='flex mt-8'>
                                    <div className='flex w-40'>
                                        <RoundedBorderButton
                                            text={strings.details}
                                            onClick={props.onClickDetails}
                                            height={48}
                                            fontWeight='700'
                                        />
                                    </div>
                                </div>
                            :   props.loggedUser.role === Constants.Roles.PORTADMIN || props.loggedUser.role === Constants.Roles.ADMINIT || props.loggedUser.role === Constants.Roles.DEALER ?
                                    <div className='flex mt-8'>
                                        <div className='flex w-40'>
                                            <RoundedBorderButton
                                                text={strings.details}
                                                onClick={props.onClickDetails}
                                                height={48}
                                                fontWeight='700'
                                            />
                                        </div>
                                    </div>
                                : null
                        
                        :   props.item && props.item.scheduleStatusId === Constants.ScheduleStatus.RESCHEDULE ?
                                props.item && props.item.entityId === docapescaId ?
                                    <div className='flex flex-row justify-between mt-8'>
                                        <div className='flex w-40 me-[11.5rem]'>
                                            <RoundedButton 
                                                onClick={props.onClickCancel}
                                                text={strings.cancel}
                                                height={48}
                                                bgColor='#E85F5C'
                                            />
                                        </div>

                                        <div className='flex w-40'>
                                            <RoundedBorderButton
                                                text={strings.details}
                                                onClick={props.onClickDetails}
                                                height={48}
                                                fontWeight='700'
                                            />
                                        </div>
                                
                                    </div>
                                :   props.loggedUser.role === Constants.Roles.ADMINIT || props.loggedUser.role === Constants.Roles.DEALER ?
                                        <div className='flex flex-row justify-between mt-8'>
                                            <div className='flex w-40 me-[11.5rem]'>
                                                <RoundedButton 
                                                    onClick={props.onClickCancel}
                                                    text={strings.cancel}
                                                    height={48}
                                                    bgColor='#E85F5C'
                                                />
                                            </div>

                                            <div className='flex w-40'>
                                                <RoundedBorderButton
                                                    text={strings.details}
                                                    onClick={props.onClickDetails}
                                                    height={48}
                                                    fontWeight='700'
                                                />
                                            </div>
                                    
                                        </div>
                                    :   props.loggedUser.role === Constants.Roles.PORTADMIN ?
                                            <div className='flex mt-8'>
                                                <div className='flex w-40'>
                                                    <RoundedBorderButton
                                                        text={strings.details}
                                                        onClick={props.onClickDetails}
                                                        height={48}
                                                        fontWeight='700'
                                                    />
                                                </div>
                                            </div>
                                        : null

                            :    props.item && props.item.entityId === docapescaId ?
                                    <div className='flex flex-row justify-between mt-8'>
                                        <div className='flex w-40 me-[11.5rem]'>
                                            <RoundedButton 
                                                onClick={props.onClickReject}
                                                text={strings.reject}
                                                height={48}
                                                bgColor='#E85F5C'
                                            />
                                        </div>

                                        <div className='flex flex-row space-x-4'>
                                            <div className='flex w-40'>
                                                <RoundedBorderButton
                                                    text={strings.details}
                                                    onClick={props.onClickDetails}
                                                    height={48}
                                                    fontWeight='700'
                                                />
                                            </div>

                                            { props.item && props.item.scheduleTypeId === Constants.ScheduleTypes.FACILITIES ? null
                                            :   <div className='flex w-40'>
                                                    <RoundedButton 
                                                        onClick={props.onClickSuggest}
                                                        text={strings.suggest}
                                                        height={48}
                                                        bgColor='#007EB4'
                                                    />
                                                </div>
                                            }
                                            
                                            <div className='flex w-40'>
                                                <RoundedButton 
                                                    onClick={props.onClickAccept}
                                                    text={strings.accept}
                                                    height={48}
                                                    bgColor='#26AB93'
                                                />
                                            </div>
                                        </div>
                                
                                    </div>
                                :   props.loggedUser.role === Constants.Roles.ADMINIT || props.loggedUser.role === Constants.Roles.DEALER ?
                                        <div className='flex flex-row justify-between mt-8'>
                                            <div className='flex w-40 me-[11.5rem]'>
                                                <RoundedButton 
                                                    onClick={props.onClickReject}
                                                    text={strings.reject}
                                                    height={48}
                                                    bgColor='#E85F5C'
                                                />
                                            </div>

                                            <div className='flex flex-row space-x-4'>
                                                <div className='flex w-40'>
                                                    <RoundedBorderButton
                                                        text={strings.details}
                                                        onClick={props.onClickDetails}
                                                        height={48}
                                                        fontWeight='700'
                                                    />
                                                </div>

                                                { props.item && props.item.scheduleTypeId === Constants.ScheduleTypes.FACILITIES ? null
                                                :   <div className='flex w-40'>
                                                        <RoundedButton 
                                                            onClick={props.onClickSuggest}
                                                            text={strings.suggest}
                                                            height={48}
                                                            bgColor='#007EB4'
                                                        />
                                                    </div>
                                                }
                                                
                                                <div className='flex w-40'>
                                                    <RoundedButton 
                                                        onClick={props.onClickAccept}
                                                        text={strings.accept}
                                                        height={48}
                                                        bgColor='#26AB93'
                                                    />
                                                </div>
                                            </div>
                                    
                                        </div>

                                    :   props.loggedUser.role === Constants.Roles.PORTADMIN ?
                                            <div className='flex mt-8'>
                                                <div className='flex w-40'>
                                                    <RoundedBorderButton
                                                        text={strings.details}
                                                        onClick={props.onClickDetails}
                                                        height={48}
                                                        fontWeight='700'
                                                    />
                                                </div>
                                            </div>
                                    : null  
                    }  
                    
                </div>
            
            </div>
        </Modal>
    )
}

export default ScheduleInfoModal